import React from "react"

import { NO, YES, NONE, UNLIMITED, VALUE } from "const"
import { LangType } from "client/store"
import { TableColumnEditable } from "client/components"

import { MtPackage } from "server/models"

import TableSelect from "../components/select"
import { styleOffset } from "./index"

const Sil = (lang: LangType) => {
    const columns: TableColumnEditable[] = [
        {
            field: "silMasterAccess",
            header: lang.silMasterAccess,
            formatter: (packg: MtPackage) => {
                const { silModuleAccess } = packg.settingsParsed
                return lang[silModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { silModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[silModuleAccess]}
                        label={lang.silMasterAccess}
                        property={{ silModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
        {
            field: "accountDevices",
            header: lang.accountDevices,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { silAccountDevices, silAccountDevicesValue } = packg.settingsParsed
                if (silAccountDevices === NONE) return lang.none
                if (silAccountDevices === VALUE) return silAccountDevicesValue
                if (silAccountDevices === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { silAccountDevices, silAccountDevicesValue } = packg.settingsParsed
                let title = ""
                if (silAccountDevices === NONE) title = lang.none
                if (silAccountDevices === VALUE) title = silAccountDevicesValue.toString()
                if (silAccountDevices === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.accountDevices}
                        property={{ silAccountDevices }}
                        propertyValue={{ silAccountDevicesValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "accountSubsystems",
            header: lang.accountSubsystems,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { silAccountSubsystems, silAccountSubsystemsValue } = packg.settingsParsed
                if (silAccountSubsystems === NONE) return lang.none
                if (silAccountSubsystems === VALUE) return silAccountSubsystemsValue
                if (silAccountSubsystems === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { silAccountSubsystems, silAccountSubsystemsValue } = packg.settingsParsed
                let title = ""
                if (silAccountSubsystems === NONE) title = lang.none
                if (silAccountSubsystems === VALUE) title = silAccountSubsystemsValue.toString()
                if (silAccountSubsystems === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.accountSubsystems}
                        property={{ silAccountSubsystems }}
                        propertyValue={{ silAccountSubsystemsValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "safetyFunctions",
            header: lang.safetyFunctions,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { silSafetyFunctions, silSafetyFunctionsValue } = packg.settingsParsed
                if (silSafetyFunctions === NONE) return lang.none
                if (silSafetyFunctions === VALUE) return silSafetyFunctionsValue
                if (silSafetyFunctions === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { silSafetyFunctions, silSafetyFunctionsValue } = packg.settingsParsed
                let title = ""
                if (silSafetyFunctions === NONE) title = lang.none
                if (silSafetyFunctions === VALUE) title = silSafetyFunctionsValue.toString()
                if (silSafetyFunctions === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.safetyFunctions}
                        property={{ silSafetyFunctions }}
                        propertyValue={{ silSafetyFunctionsValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "silCalculations",
            header: lang.calculations,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { silCalculations, silCalculationsValue } = packg.settingsParsed
                if (silCalculations === NONE) return lang.none
                if (silCalculations === VALUE) return silCalculationsValue
                if (silCalculations === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { silCalculations, silCalculationsValue } = packg.settingsParsed
                let title = ""
                if (silCalculations === NONE) title = lang.none
                if (silCalculations === VALUE) title = silCalculationsValue.toString()
                if (silCalculations === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.calculations}
                        property={{ silCalculations }}
                        propertyValue={{ silCalculationsValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "silReports",
            header: lang.reports,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { silReports, silReportsValue } = packg.settingsParsed
                if (silReports === NONE) return lang.none
                if (silReports === VALUE) return silReportsValue
                if (silReports === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { silReports, silReportsValue } = packg.settingsParsed
                let title = ""
                if (silReports === NONE) title = lang.none
                if (silReports === VALUE) title = silReportsValue.toString()
                if (silReports === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.reports}
                        property={{ silReports }}
                        propertyValue={{ silReportsValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
    ]

    return columns
}
export default Sil
